import Player from 'video.js/dist/types/player';
import { useStore } from 'zustand';
import { PlaybackStoreApi } from '../context/playback.context';
import { usePlaybackStore } from '../hooks/usePlayback';
import type { VideoPlaybackStore, VideoPlaybackStoreApi } from './useVideoPlaybackStore';

/**
 * Type guard to check if store is video store
 */
export function isVideoStore(store: PlaybackStoreApi): store is VideoPlaybackStoreApi {
  return 'videoJsPlayer' in store.getState();
}

/**
 * Hook to select state from the video playback store.
 * Throws an error if the store is not a video store.
 */

export function useVideoPlaybackState<T>(selector: (s: VideoPlaybackStore) => T): T {
  const store = usePlaybackStore();

  if (!isVideoStore(store)) {
    throw new Error('useVideoPlaybackState requires a video playback store');
  }

  return useStore(store, selector);
}

/**
 * Hook to get the videojs player instance from the video playback store.
 * Returns null if the player is not yet initialized.
 * Throws an error if the store is not a video store.
 */
export function usePlaybackVideoJsPlayer(): Player | null {
  return useVideoPlaybackState((s) => s.videoJsPlayer);
}
